import React ,{useEffect,useState}from "react"
import { withRouter,useParams } from "react-router-dom"
import { connect,useSelector } from "react-redux"
import moment from "moment"
import { isEmpty} from "lodash"
import Modal from "react-bootstrap/Modal"
import {
  Col,
  UncontrolledTooltip,
  Table,
  Button,
  Row,
} from "reactstrap"
import PropTypes from "prop-types"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import { ToastContainer } from "react-toastify"
import * as freeAction from "../../store/b3BlcmF0aW9uc0/actions"
// import "./styles.scss"


const OperationsFreelancerQc = (props) => {
  const { dispatch } = props
  let { id } = useParams()
  const payload = {
    leadId:id,
    type:"freelancerQc"
  }
  useEffect(() => {
    dispatch(freeAction.loadEcEvent(payload))
  }, [1])

const update = useSelector(state => state.operationsFollowUp)
const { event_list = [] } = update
const sessionUpdate = useSelector((specificstate) => specificstate.session)
const { user = [] } = sessionUpdate

//date format from localstorage
const authUser = localStorage.getItem("authUser")

const dateLogin = JSON.parse(authUser)

const setDate =
  !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
    ? dateLogin.setting.dateFormate.toUpperCase()
    : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
      const [attachmentModal, setAttachmentModal] = useState(false)
      const [attachmentDetails,setAttachmentDetails] = useState("")
const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
  //Data Table section
  const freelancerTable = !isEmpty(event_list)&&event_list.length>0?
  event_list.map((data,index)=>{
    const createdByName = data.createdByName?data.createdByCode+"-"+data.createdByName:"--"
    return{
      sNo:index+1,
      date:data.eventDate?moment(data.eventDate).format(dateFormat):"--",
      event:data.eventName?data.eventName:"--",
      FreelancerQc:data.remarks?data.remarks:"--",
      attachments:data.attachment,
      createdBy:createdByName,
      createdOn:data.createdOn
    }
  }):[]



  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "date",
      text: "Date",
    },
    {
      dataField: "event",
      text: "Event",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "FreelancerQc",
      text: "Freelancer Qc",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "attachments",
      text: "Attachment",
      editable: false,
      csvExport: false,
      formatter: (cellContent, row) => {
        const attachCount =
          !isEmpty(row.attachments) && row.attachments.length > 0
            ? row.attachments.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(row.crmAttachments) ? (
                  <a
                    onClick={() => {
                      setAttachmentModal(true)
                      setAttachmentDetails(row.attachments)
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "createdBy",
      text: "Created By",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "createdOn",
      text: "Created On",
      headerStyle: {
        minWidth: "130px",
      },
    },
   

  ]
 
// pagination options
const options = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
 


  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <p className="quote-head">
          Freelancer Qc
          <span className="quote-info">
            <i
              style={{ color: "grey" }}
              id="DeliverableInfo"
              aria-hidden="true"
              className="fa fa-info-circle ms-1"
            ></i>
            <UncontrolledTooltip placement="right" target="DeliverableInfo">
              Freelancer Qc
            </UncontrolledTooltip>
          </span>
        </p>

        <Col md="12" lg="12" xl="12" className="mt-3">
          <PaginationProvider
            pagination={paginationFactory(options)}
            keyField="_id"
            columns={columns}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="_id"
                data={freelancerTable}
                columns={columns}
                search
                exportCSV
              >
                {(props) => (
                  <div>
                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                      <Row className="d-flex flex-row  ">
                       
                        <Col>
                          <BootstrapTable
                            {...props.baseProps}
                            responsive
                            striped={true}
                            bordered={true}
                            keyField="_id"
                            columns={columns}
                            {...paginationTableProps}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginTop: "5px" }}
                        className="align-items-md-center mt-30"
                      >
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline d-flex flex-row">
                            <SizePerPageDropdownStandalone
                              {...paginationProps}
                            />
                            <div
                              style={{
                                fontSize: "14px",
                                marginTop: "8px",
                                marginLeft: "4px",
                              }}
                            >
                              <PaginationTotalStandalone
                                {...paginationProps}
                              />
                            </div>
                          </div>
                          <div
                            className="text-md-right ms-auto"
                            style={{ zIndex: 0 }}
                          >
                            <PaginationListStandalone
                              {...paginationProps}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </Col>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
 {attachmentModal && (
        <Modal show={attachmentModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Attachment
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(attachmentDetails) &&
                      attachmentDetails.length > 0 ? (
                      attachmentDetails.map((item, index) => {
                        const splitAttach = !isEmpty(item)
                          ? item.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                {(item && attachExtension === "jpeg") ||
                                  (item && attachExtension === "jpg") ||
                                  (item && attachExtension === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && attachExtension === "mp3") ||
                                  (item && attachExtension === "m4a") ||
                                  (item && attachExtension === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setAttachmentModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}


      </Row>
    </React.Fragment>
  )
}
OperationsFreelancerQc.propTypes = {
  dispatch: PropTypes.func,
  record_quotation_details: PropTypes.array,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OperationsFreelancerQc)
)
